<div id="eventInfo">
    <h2>Credentials <ng-container *ngIf="selectableRows">({{selectedCredentials?.length}} selected)</ng-container><button class="icon--add btn--default" type="button" (click)="addCredential()" *ngIf="showAddCredential">Add Credential</button></h2>
    <p-table #dt [value]="drivingRecordCredentials" [rows]="10" [paginator]="true" [dataKey]="'id'" [(selection)]="selectedCredentials" [expandedRowKeys]="expandedRows">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="8 + (showActions ? 1 : 0)">
                    No Records Found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th class="w--icon text-center" *ngIf="selectableRows">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th class="w--arrow" *ngIf="!selectableRows"></th>
                <th pSortableColumn="jurisdictionDescription" class="w--date-short">State of License<p-sortIcon field="jurisdictionDescription"></p-sortIcon></th>
                <th pSortableColumn="credentialType">Credential Type<p-sortIcon field="credentialType"></p-sortIcon></th>
                <th pSortableColumn="issueDate" class="w--date-short">Issue Date<p-sortIcon field="issueDate"></p-sortIcon></th>
                <th pSortableColumn="expirationDate" class="w--date-short">Expiration Date<p-sortIcon field="expirationDate"></p-sortIcon></th>
                <th pSortableColumn="status" class="w--status">Status<p-sortIcon field="status"></p-sortIcon></th>
                <th pSortableColumn="updatedBy">Updated By<p-sortIcon field="updatedBy"></p-sortIcon></th>
                <th pSortableColumn="statusDate" class="w--date-short">Status Date<p-sortIcon field="statusDate"></p-sortIcon></th>
                <th *ngIf="showActions || hasOOJCredential" [ngClass]="{'w--icon': !showActions && hasOOJCredential}">Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-expanded="expanded">
            <tr [pSelectableRow]="data">
                <td class="w--icon" *ngIf="selectableRows">
                    <p-tableCheckbox [value]="data"></p-tableCheckbox>
                </td>
                <td *ngIf="!selectableRows">
                    <a href="javascript:void(0)" [pRowToggler]="data">
                        <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                    </a>
                </td>
                <td>{{ data.jurisdictionDescription }}</td>
                <td>{{ data.credentialType }}</td>
                <td>{{ data.issueDate | shortDate }}</td>
                <td>{{ data.expirationDate | shortDate }}</td>
                <td>{{ data.status }}</td>
                <td class="td--hover-show">{{ data.statusUpdatedBy }}</td>
                <td>{{ data.statusDate | shortDate }}</td>
                <td *ngIf="showActions">
                    <ng-container *ngIf="!isBaseJurisdiction(data.jurisdictionDescription) || data.canDuplicate || data.canRenew">
                        <select class="mvd_form-control" (change)="onActionChange($event, data.id)" [(ngModel)]="data.driverApplicationActionTypeId" [ngModelOptions]="{standalone: true}">
                            <option value="0">- Select -</option>
                            <option value="Edit" *ngIf="!isBaseJurisdiction(data.jurisdictionDescription) && canEditOOJCredential">Edit</option>
                            <option value="3" *ngIf="isBaseJurisdiction(data.jurisdictionDescription) && data.canDuplicate">Duplicate</option>
                            <option value="2" *ngIf="isBaseJurisdiction(data.jurisdictionDescription) && data.canRenew">Renewal</option>
                        </select>
                    </ng-container>
                </td>
                <td *ngIf="!showActions && hasOOJCredential">
                    <ng-container *ngIf="!isBaseJurisdiction(data.jurisdictionDescription)">
                        <a class="icon--edit" href="javascript:void(0)" title="Edit Credential" (click)="editOOJCredential(data.id)" *ngIf="canEditOOJCredential"></a>
                        <a class="icon--delete" href="javascript:void(0)" title="Delete Credential" (click)="deleteOOJCredential(data.id)" *ngIf="canDeleteOOJCredential"></a>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-data>
            <tr>
                <td [attr.colspan]="8 + (showActions || hasOOJCredential ? 1 : 0)">
                    <driver-record-credential
                        [data]="data"
                        [isUserLecu]="isUserLecu"
                        [isRestrictedCustomer]="isRestrictedCustomer">
                    </driver-record-credential>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>